export const BUILD_VERSION = {
  buildNumber: 117,
  buildDate: "24_06_2026",
  platform: "web",
  version: "web/1.0.4/24_06_2026",
  releaseVersion: "v1.0.4",
};
